export enum AdminDocDivision {
  CCL = 'ccl',
  TSF = 'tsf',
  Company = 'company',
  OnboardingCCL = 'onboarding-ccl',
  OnboardingTSF = 'onboarding-tsf',
}

export enum AdminDocStatus {
  Open = 'open',
  Done = 'done',
}

export const ADMIN_DOC_DEPARTMENTS = [
  'Admin',
  'Analyst',
  'Document Processors',
  'Titling',
  'Development Specialist',
  'Controllers',
] as const;
export type AdminDocDepartment = (typeof ADMIN_DOC_DEPARTMENTS)[number];

export interface AdminDocFile {
  fileName: string;
  fileUrl: string;
  label?: string;
  /** Full name of user who uploaded the file */
  uploadedBy?: string;
  /** Cognito user sub (stable user id) of the uploader */
  uploadedBySub?: string;
  /** Timestamp (ms) when the file was uploaded */
  uploadedAt?: number;
  /** Object is in the public/ S3 folder (see publicFileKey). */
  isPublic?: boolean;
  /** While published: public/{fileUrl}. Object moves here from fileUrl. */
  publicFileKey?: string;
  /** Direct HTTPS URL when the object lives under public/ */
  publicUrl?: string;
}

export interface AdminDoc {
  id: string;
  name: string;
  division: AdminDocDivision;
  department: AdminDocDepartment;
  status: AdminDocStatus;
  description: string;
  documents: AdminDocFile[];
  createdAt: number;
  updatedAt?: number;
  order?: number;
}
